import SideMenuItem from './SideMenuItem';

export default SideMenuItem;
